import { useFormAgenda } from 'hooks/useFormAgenda';
import FormPaciente from 'pages/paciente/FormPaciente';
import { Card, Form, Modal } from 'react-bootstrap';
import FormAgendaFields from './FormAgendaFields';

export default function FormAgenda({
  show,
  onHide,
  medicoSelecionado,
  onAgendaCreated,
  agendaContext = null,
  dataSelecionada,
  agendasDoDia = [],
  hookData: externalHookData = null,
}) {
  const internalHookData = useFormAgenda({
    show: externalHookData ? false : show,
    agendaContext,
    medicoSelecionado,
    dataSelecionada,
    agendasDoDia,
    onAgendaCreated,
    onHide,
  });

  const hookData = externalHookData || internalHookData;

  if (!show) return null;

  const {
    handleSubmit,
    onSubmit,
    register,
    showPacienteModal,
    setShowPacienteModal,
    handleSelectPaciente,
  } = hookData;

  return (
    <>
      <Modal show={showPacienteModal} onHide={() => setShowPacienteModal(false)} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Localizar Paciente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormPaciente
            show={true}
            onHide={() => setShowPacienteModal(false)}
            onSelectPaciente={handleSelectPaciente}
          />
        </Modal.Body>
      </Modal>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <Card className="mb-2 shadow-sm" style={{ border: '1px solid #1f6f3b' }}>
          <Card.Body style={{ padding: '0.55rem 0.6rem' }}>
            <FormAgendaFields
              hookData={hookData}
              register={register}
              agendaContext={agendaContext}
            />
          </Card.Body>
        </Card>
      </Form>
    </>
  );
}
